/** Android app releases (owner request 2026-10-21): uploaded in the portal, downloaded from /download. */
import { z } from "zod";
export const AppRelease = z.object({
    id: z.uuid(),
    versionName: z.string(),
    /** The app compares it with its own runtime version to offer the new APK. */
    runtimeVersion: z.string().nullable(),
    notes: z.string().nullable(),
    size: z.number().int(),
    sha256: z.string(),
    createdAt: z.string(),
    /** Relative to the API: GET it to download the APK. */
    downloadPath: z.string(),
});
export const LatestAppReleaseResponse = z.object({ release: AppRelease.nullable() });
/** Query of PUT /v1/app-releases/android (the body is the APK itself). */
export const UploadAppReleaseQuery = z.object({
    organizationId: z.uuid(),
    versionName: z.string().trim().min(1).max(40),
    notes: z.string().trim().max(1000).optional(),
});
export const APK_MAX_BYTES = 200 * 1024 * 1024;
//# sourceMappingURL=app-releases.js.map